// extracted by mini-css-extract-plugin
export default {"dont-expand-to-fit":"DataGridPreferences-module__dont-expand-to-fit__3RfcS"};